// Stand-ins for a signed-in Google user, for development only. The token is
// the name, and the dev server turns each token into an account of its own, so
// several players can be signed in at once in different tabs.
const devUserNamed = (name) => ({
  name,
  getBasicProfile() {
    return {
      getGivenName() {
        return name;
      },
    };
  },
  getAuthResponse() {
    return { id_token: name };
  },
});

const devUsers = [devUserNamed("dev"), devUserNamed("dev2"), devUserNamed("dev3")];

const devUser = devUsers[0];

export { devUser, devUsers };
